module.exports = __webpack_public_path__ + "img/blog-2.c5a0e4eb.webp";